import React from "react";

const FeatureCard = ({ icon, title }) => (
  <div className="flex justify-center items-start space-x-4 max-w-[500px]">
    <div className="text-blue-700 text-2xl">{icon}</div>
    <p className="text-md font-semibold text-start">{title}</p>
  </div>
);

export default FeatureCard;
